(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.ROICalculator = {
    attach: function (context, settings) {
      var buttons = once("roi-calculator", "#roi-calculator-action-calculate", context);
      //console.log(buttons.length);
      buttons.forEach(function(calc) {
        $(calc).on("click", function() {
          Drupal.behaviors.ROICalculator.calculateROI();
        });
      });
    },
    calculateROI: function() {
      var costPerDay = parseInt($("#sick-leave-cost").val());
      var workersNum = parseInt($("#number-of-employees").val());
      var musculoscetalShare = parseInt($("#musculoscetal-share").val());
      var sickDaysYear = parseInt($("#number-of-sickleaves").val());
      var sickDaysReduction = parseInt($("#sick-days-reduction").val());
      var savings = costPerDay * workersNum * (sickDaysYear * musculoscetalShare/100) * (sickDaysReduction / 100);
      var reduction = Math.round(workersNum * (sickDaysYear * musculoscetalShare/100) * (sickDaysReduction / 100));
      Drupal.behaviors.ROICalculator.updateValues(savings, reduction);
    },
    updateValues: function(savings, reduction) {
      var lang = $("#roi-calculator-results-table").attr("data-lang");
      $("#roi-calculator-results").css("display", "block");
      var currency = lang != "en" ? $("#sick-leave-cost-currency").attr("data-currency") : "";
      var days = $("#days-reduction-row").attr("data-days");
      var steps = 30;

      var i = 0;
      var intervalId = setInterval(function() {
          $("#savings1").html(parseInt(savings * i / steps).toLocaleString('fi-FI') + " " + currency);
          $("#savings5").html(parseInt(savings * i * 5 / steps ).toLocaleString('fi-FI') + " " + currency);
          $("#reductions1").html(parseInt(reduction * i / steps).toLocaleString('fi-FI') + " " + days);
          $("#reductions5").html(parseInt(reduction * i * 5 / steps ).toLocaleString('fi-FI') + " " + days);
          if(i >= steps) {
            clearInterval(intervalId);
          }
          i++;
          console.log(i);
        }, 30);
    }
  };


})(jQuery, Drupal);